/**
 * „Primii pași”: lista de pe panou pentru o firmă nouă. Pașii se bifează
 * singuri, din ce există deja în cont; nu se ține nimic în plus în bază, în
 * afară de „Ascunde lista”.
 */

/** Ce are firma acum, numărat de server. */
export interface OnboardingFacts {
  /** CUI și adresa sediului completate: fără ele, comanda iese fără datele firmei */
  companyData: boolean;
  sites: number;
  /** furnizori nearhivați */
  suppliers: number;
  rfqs: number;
  /** colegi activi în afară de tine, plus invitațiile încă bune */
  colleagues: number;
  /**
   * Firma a lucrat deja: o cerere de orice fel (și comanda rapidă face una) sau un necesar din șantier.
   * Până atunci panoul arată doar „Primii pași”, nu zece cartonașe cu zero (2026-11-03).
   */
  started: boolean;
  /** oferte primite, pe toate cererile: graficele panoului apar de la prima (Ticket 08, C9) */
  offers: number;
  /** cereri la care s-a ales furnizorul: pasul „Compară” e gata */
  chosen: number;
  /** cererea pe care o deschide pasul „Compară”: cea mai nouă încă nealeasă, cu ofertele ei */
  compareRfqId: string | null;
}

export type OnboardingStepId = 'site' | 'suppliers' | 'rfq' | 'compare' | 'team';

export interface OnboardingStep {
  id: OnboardingStepId;
  done: boolean;
}

/** Destui cât să ai ce compara: o cerere are rost de la trei oferte. */
export const ONBOARDING_SUPPLIERS = 3;

/**
 * Ordinea: drumul până la prima alegere (locul, furnizorii, cererea, comparația), fiindcă acolo vede
 * omul rostul aplicației. Datele firmei nu mai sunt un pas: se cer la prima comandă, singurul loc unde
 * trebuie (Ticket 08, C9; înainte erau pasul 1, apoi pasul 4).
 */
export function onboardingSteps(f: OnboardingFacts): OnboardingStep[] {
  return [
    { id: 'site', done: f.sites > 0 },
    { id: 'suppliers', done: f.suppliers >= ONBOARDING_SUPPLIERS },
    { id: 'rfq', done: f.rfqs > 0 },
    { id: 'compare', done: f.chosen > 0 },
    { id: 'team', done: f.colleagues > 0 },
  ];
}
